import http from "@/utils/http";

//更新日志列表
export const queryReleaseNotesList = (pageIndex, pageSize) => http.get('nonlogin/release/notes/queryAll.htm', {
    pageIndex: pageIndex,
    pageSize: pageSize
});

export const releaseNotesDetail = (id) => http.get('nonlogin/release/notes/detailById.htm?id='+id)